(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/qr-scanner/assets/javascripts/qr-scanner.js') >= 0) return;  svs.modules.push('/components/tur/qr-scanner/assets/javascripts/qr-scanner.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const _svs$tur$qrScanner$co = svs.tur.qrScanner.components,
  FocusBox = _svs$tur$qrScanner$co.FocusBox,
  MessageBox = _svs$tur$qrScanner$co.MessageBox;
const _svs$tur$qrScanner$ut = svs.tur.qrScanner.utils,
  scanQRCodeWithJsQR = _svs$tur$qrScanner$ut.scanQRCodeWithJsQR,
  showFooter = _svs$tur$qrScanner$ut.showFooter,
  hideFooter = _svs$tur$qrScanner$ut.hideFooter,
  disableBodyScroll = _svs$tur$qrScanner$ut.disableBodyScroll,
  enableBodyScroll = _svs$tur$qrScanner$ut.enableBodyScroll,
  addListenerForVisibilityChange = _svs$tur$qrScanner$ut.addListenerForVisibilityChange,
  removeListenerForVisibilityChange = _svs$tur$qrScanner$ut.removeListenerForVisibilityChange,
  showErrorDialog = _svs$tur$qrScanner$ut.showErrorDialog;
const qrLogger = new svs.core.log.Logger('qr-scanner');
setGlobal('svs.tur.qrScanner.qrLogger', qrLogger);
const QrScanner = _ref => {
  let onClose = _ref.onClose,
    _ref$validateQrCode = _ref.validateQrCode,
    validateQrCode = _ref$validateQrCode === void 0 ? _.noop : _ref$validateQrCode,
    _ref$notAllowedErrorA = _ref.notAllowedErrorAction,
    notAllowedErrorAction = _ref$notAllowedErrorA === void 0 ? null : _ref$notAllowedErrorA;
  const videoParentRef = useRef(null);
  const scannerRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    started = _useState2[0],
    setStarted = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    closed = _useState4[0],
    setClosed = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    message = _useState6[0],
    setMessage = _useState6[1];
  const destroyed = useRef(false);
  const destroy = () => {
    var _scannerRef$current;
    if (destroyed.current) {
      return;
    }
    qrLogger.info('QR-scanner closed');
    destroyed.current = true;
    onClose === null || onClose === void 0 || onClose();
    setClosed(true);
    enableBodyScroll();
    (_scannerRef$current = scannerRef.current) === null || _scannerRef$current === void 0 || _scannerRef$current.stop();
    showFooter();
    removeListenerForVisibilityChange();
  };
  const onError = e => {
    var _e$name;
    qrLogger.warn('QR-scanner error', e);
    if ((e === null || e === void 0 || (_e$name = e.name) === null || _e$name === void 0 ? void 0 : _e$name.toLowerCase()) === 'notallowederror') {
      showErrorDialog({
        customAction: notAllowedErrorAction,
        title: 'Tillåtelse att använda kameran saknas',
        message: 'Se till att din webbläsare har tillåtelse att använda kameran, eller öppna din kamera-app. Försök sedan att scanna qr-koden igen.'
      });
      destroy();
      return;
    }
    showErrorDialog({
      message: 'Tekniskt fel',
      onClick: destroy
    });
  };
  useEffect(() => {
    const startScanner = async ref => {
      disableBodyScroll();
      hideFooter();
      svs.ui.loader.show();
      scannerRef.current = scanQRCodeWithJsQR(ref, destroy);
      try {
        await scannerRef.current.start({
          validateQrCode,
          setMessage
        });
        addListenerForVisibilityChange(destroy);
        setStarted(true);
        qrLogger.info('QR-scanner started');
      } catch (e) {
        onError(e);
      } finally {
        svs.ui.loader.hide();
      }
    };
    !started && startScanner(videoParentRef.current);
    return () => {
      destroy();
    };
  }, []);
  if (closed) {
    return null;
  }
  return React.createElement("div", {
    className: "absolute qr-scanner-container"
  }, React.createElement("div", {
    ref: videoParentRef
  }), started && React.createElement("div", {
    className: "relative qr-scanner-ui-container"
  }, React.createElement("div", {
    className: "absolute padding-1 u-top-0 u-right-0"
  }, React.createElement(IconButton, {
    onClick: destroy
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: "close",
    size: "500"
  }))), React.createElement(FocusBox, null), React.createElement(MessageBox, {
    invalid: message === null || message === void 0 ? void 0 : message.error,
    message: message === null || message === void 0 ? void 0 : message.message,
    url: message === null || message === void 0 ? void 0 : message.url
  })));
};
setGlobal('svs.tur.qrScanner.QrScanner', QrScanner);

 })(window);